import * as actionTypes from 'constants/ActionTypes';
import * as tcOrderActions from 'actions/tc/orders';
import _ from 'lodash';
import { call, put } from 'redux-saga/effects';

function fillAndCreateTcOrders(clarified) {
    const newClarified = _.cloneDeep(clarified);

    return newClarified;
}

// eslint-disable-next-line import/prefer-default-export
export function* createTcOrders(response) {
    const tcOrders = [];
    
    if (response.status === 200) {
        if (response.data.clarified) {
            const clarifiedOnlyTc = response.data.clarified.filter(c => c.typeCategory.includes('tc'));
            
            if (clarifiedOnlyTc.length > 0) {
                for (let key = 0; key < clarifiedOnlyTc.length; key++) {
                    try {
                        tcOrders.push(yield call(fillAndCreateTcOrders, clarifiedOnlyTc[key]));
                    } catch (e) {
                        yield put({
                            type: actionTypes.ADD_NOTIFICATION,
                            notification: {
                                title: 'Error',
                                message: 'Something went wrong',
                                level: 'error',
                                _id: new Date().getMilliseconds(),
                                autoDismiss: 4,
                            },
                        });
    
                        console.error(e);
                    }
                }
    
                yield put({
                    type: actionTypes.ADD_NOTIFICATION,
                    notification: {
                        title: 'Created',
                        message: `The ${tcOrders.length} tc orders created`,
                        level: 'success',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 4,
                    },
                });
    
                yield put(tcOrderActions.createTcOrders(tcOrders));
                return;
            } 
        }

        yield put(tcOrderActions.resetTcOrders());

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The tc orders did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });
    } else {
        yield put(tcOrderActions.addTcOrder());

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The tc orders did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./app/sagas/tc/orders.js